import { AppShell, Button, Group, NavLink, Text, Title } from '@mantine/core';
import { NavLink as RouterNavLink, Outlet } from 'react-router';

import { useLogout } from '../features/auth';
import { env } from '../shared/config/env';
import { useSession } from '../shared/session';
import { sections } from './sections';

/** Каркас панели: боковая навигация и область экрана (AD-A7). Разделы — `sections.ts`. */
export function Shell() {
  const session = useSession();
  const logout = useLogout();

  return (
    <AppShell header={{ height: 56 }} navbar={{ width: 220, breakpoint: 'sm' }} padding="md">
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Title order={4}>Aura — админ</Title>
          <Group gap="sm">
            <Text size="sm" c="dimmed" title={session?.id}>
              {session?.roles.join(', ')}
            </Text>
            <Button
              variant="subtle"
              size="xs"
              loading={logout.isPending}
              onClick={() => logout.mutate()}
            >
              Выйти
            </Button>
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Navbar p="xs">
        {sections.map((section) => (
          <NavLink
            key={section.to}
            component={RouterNavLink}
            to={section.to}
            label={section.label}
          />
        ))}
        {/* Панель обязана уметь назвать контракт, под который собрана (AD-A2): тег запечён
            в бандл, а до этого его никто не показывал. Дайджест — в подсказке: на экране он
            только шум, а при разборе «почему поле пустое» нужен точный. */}
        {env.contract.tag ? (
          <Text size="xs" c="dimmed" mt="auto" p="xs" title={env.contract.sha256}>
            контракт {env.contract.tag}
          </Text>
        ) : null}
      </AppShell.Navbar>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
